import { ChartData } from 'chart.js';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { TransactionsSuccessSummary } from 'types/embedded/dashboard';

export function useDashboardTransactionsSummaryChartData(
  summary?: TransactionsSuccessSummary,
): ChartData<'doughnut', (number | undefined)[], string> {
  const translate = useTypedTranslate();

  return {
    labels: [
      translate('app.dashboard.successfulTransactionsSummary.successful'),
      translate('app.dashboard.successfulTransactionsSummary.refused'),
      translate('app.dashboard.successfulTransactionsSummary.pending'),
    ],
    datasets: [
      {
        data: [summary?.successful.count, summary?.refused.count, summary?.pending.count],
        backgroundColor: ['#81C784', '#EF5350', '#FDD835'],
        hoverOffset: 2,
      },
    ],
  };
}
